import * as React from 'react';
import client from '../api/contentful';
import { Entry } from 'contentful';

interface IAbout {
  header: string;
  subtitle: string;
  description: string;
  clients: string[];
  awards: Array<Entry<IAward>>;
  image: Entry<IImage>;
  pressLinks: Array<Entry<IPressLink>>;
  metaImage: Entry<IImage>;
  metaTitlePrefix: string;
  metaTitleDefaultSuffix: string;
}

interface IAward {
  title: string;
  year: number;
}

interface IImage {
  description: string;
  file: {
    url: string;
    contentType: string;
    details: {
      image: {
        height: number;
        width: number;
      };
    };
  };
}

interface IPressLink {
  year: number;
  articleName: string;
  articleUrl: string;
}

export type AboutEntry = Entry<IAbout>;

export default class About {
  static data: AboutEntry;
  private static promise: Promise<AboutEntry>;

  static getData(): Promise<AboutEntry> {
    if (About.promise) {
      return About.promise;
    }

    const promise = client
      .getEntries<IAbout>({
        content_type: 'aboutPage',
      })
      .then((data) => {
        About.data = data.items[0];

        return data.items[0];
      });

    About.promise = promise;

    return promise;
  }
}

export interface IRenderProps {
  data: AboutEntry;
}

interface IProps {
  render:
    | ((props: IRenderProps) => React.ReactNode)
    | React.ComponentClass<IRenderProps>;
  fallback?: React.SFC | React.ComponentClass;
  [key: string]: any;
}

interface IState {
  data: AboutEntry | undefined;
}

function isComponentClass(render: any): render is React.ComponentClass {
  return undefined !== render.prototype.isReactComponent;
}

const blackList = new Set(['render', 'fallback']);

export class AboutRenderer extends React.PureComponent<IProps, IState> {
  state: IState = {
    data: undefined,
  };

  componentDidMount() {
    this.fetch();
  }

  fetch() {
    About.getData().then((data) => this.setState({ data }));
  }

  render() {
    const extraProps = Object.keys(this.props).reduce((acc, key) => {
      if (!blackList.has(key)) {
        acc[key] = this.props[key];
      }
      return acc;
    }, {});

    if (this.state.data) {
      if (isComponentClass(this.props.render)) {
        const Render = this.props.render;
        return <Render data={this.state.data} {...extraProps} />;
      }

      return this.props.render({
        data: this.state.data,
        ...extraProps,
      });
    }

    if (this.props.fallback) {
      const Fallback = this.props.fallback;

      return <Fallback />;
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/models/About.tsx